import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignSelf: 'flex-start'
  },
  radioButton: {
    className: 'no-format',
    style: { display: 'none' }
  },
  customMargins: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    maxWidth: '250px',
    flexWrap: 'wrap'
  },
  customMarginsInput: {
    width: '100px',
    flexShrink: 0,
    '& .MuiInputBase-root': {
      height: '32px',
      '& .MuiInputBase-input': {
        border: 'none',
        '&:disabled': {
          backgroundColor: 'transparent'
        }
      }
    }
  }
});
